import { useDispatch, useSelector } from "react-redux";
import { RadioChannel } from "./styled";
import { cloneElement, useState } from "react";
import { openModal } from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
import { pause, setCurrentStreamType } from "../../redux/Slice/playerSlice";
import { playStreamAction } from "../../redux/actions/actions";
import { googleTagPlayCategoryEvent } from "../../utils/googleTagManager";

export const RadioChannelCard = ({ channel }) => {
  const dispatch = useDispatch();
  const activeStreamType = useSelector(
    (state) => state.player.currentStreamType,
  );
  const currentEntity = useSelector((state) => state.player.currentEntity);
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (type) => {
    if (activeStreamType === type && currentEntity === "track") {
      return;
    }
    if (type === "suggest") {
      return dispatch(openModal(modalState.FEEDBACK));
    }
    dispatch(pause());
    dispatch(playStreamAction(type));
    dispatch(setCurrentStreamType(type));
    googleTagPlayCategoryEvent({
      event: `Play ${type}`,
      label: "From main page",
      action: "Play from main page",
    });
  };
  return (
    <RadioChannel
      tabIndex={0}
      onClick={() => handleClick(channel.type)}
      isActive={activeStreamType === channel.type}
      duration={channel.duration}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {channel.title}
      <div>
        {cloneElement(channel.stripes, {
          isActive: activeStreamType === channel.type || isHovered,
        })}
        <img src={channel.img} alt={channel.type} />
      </div>
    </RadioChannel>
  );
};
